export const SPEED_SELECTION: number[] = [0.8, 1, 1.2, 1.5, 2];